import {useTranslations} from 'next-intl';
import {useState} from 'react';
import useDeviceDetection from '../isMobile/isMobile';
import './Tutorial.scss';

const Tutorial = () => {
  const t = useTranslations();

  const [tutorStep, setTutorStep] = useState<number>(1);
  const [isOpenTutor, setIsOpenTutor] = useState(false);
  const {isMobile} = useDeviceDetection();

  const getTutoStepDescription = () => {
    switch (tutorStep) {
      case 1:
        return <>{t.raw('Smile.upload.popup.tutorial.step1')}</>;
      case 2:
        return <>{t.raw('Smile.upload.popup.tutorial.step2')}</>;
      case 3:
        return <>{t.raw('Smile.upload.popup.tutorial.step3')}</>;
    }
  };

  return (
    <>
      {false && (
        <div
          className="tutorial-btn"
          onClick={(e) => {
            e.preventDefault();
            setTutorStep(1);
            setIsOpenTutor(true);
          }}
        >
          {t.raw('Smile.upload.popup.tutorial.btn')}
        </div>
      )}
      {isOpenTutor && (
        <div
          className="upload-preview"
          onDrop={(e) => e.stopPropagation()}
          onClick={(e) => e.preventDefault()}
        >
          <div className="preview-wrapper">
            <div className="tutorial-popup">
              <div className="popup-header">
                <div className="popup-title">
                  {t('Smile.upload.popup.tutorial.title', {
                    step: tutorStep.toString()
                  })}
                </div>
                <div
                  className="close-btn"
                  onClick={() => setIsOpenTutor(false)}
                >
                  <img alt="img" src={`/img/smile/gallery/icon-close.svg`} />
                </div>
              </div>
              <div className="popup-body">
                <div className="tutor-wrapper">
                  <div className="control-wrapper">
                    <div className="step-description">
                      {getTutoStepDescription()}
                    </div>
                    <div className="control">
                      {tutorStep > 1 && (
                        <div
                          className="prev-btn"
                          onClick={() => setTutorStep(tutorStep - 1)}
                        >
                          {t.raw('Smile.upload.popup.tutorial.prev')}
                          <img
                            src="/img/smile/upload/icon-arrow.svg"
                            alt="arrow"
                          />
                        </div>
                      )}
                      {tutorStep < 3 && (
                        <div
                          className="next-btn"
                          onClick={() => setTutorStep(tutorStep + 1)}
                        >
                          {t.raw('Smile.upload.popup.tutorial.next')}
                          <img
                            src="/img/smile/upload/icon-arrow.svg"
                            alt="arrow"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="step-image">
                    <img
                      className="image"
                      alt="tutor"
                      src={`/img/smile/upload/tutor-${tutorStep}${isMobile ? '-mb' : ''}.png`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Tutorial;
